<template>
  <VView class="menu">
    <VButtonGroup class="menu__buttons">
      <transition :name="getButtonTransitionName(item, index)"
        v-for="(item, index) in items" :key="index"
        appear
      >
        <VButton :to="item.to" :alternative="index === 2">{{ item.label }}</VButton>
      </transition>
    </VButtonGroup>
  </VView>
</template>

<script>
import VView from '@/components/VView.vue';
import VText from '@/components/VText.vue';
import VMedia from '@/components/VMedia.vue';
import VButton from '@/components/VButton.vue';
import VButtonGroup from '@/components/VButtonGroup.vue';

export default {
  name: 'Menu',
  components: {
    VView,
    VText,
    VMedia,
    VButton,
    VButtonGroup,
  },

  data() {
    return {
      items: [
        { to: '/rules', label: 'Zasady' },
        { to: '/prizes', label: 'Nagrody' },
        // { to: '/contest', label: 'Weź udział!' },
        { to: '/contest', label: 'Laureaci' },
      ],
    };
  },

  methods: {
    getButtonTransitionName(item, index) {
      return index % 2 === 0
        ? 'bounceLeft'
        : 'bounceRight';
    },
  },
};
</script>

<style lang="scss" scoped>
.menu {

}
</style>
